/** Firma compacta para evitar setState si la geometría del pentagrama no cambió. */
export function staffGeometrySignature(
  geom: Array<{ startTime: number; x: number }>
): string {
  if (geom.length === 0) return "";
  const first = geom[0];
  const last = geom[geom.length - 1];
  return `${geom.length}|${first.startTime},${first.x.toFixed(2)}|${last.startTime},${last.x.toFixed(2)}`;
}
